import { render, staticRenderFns } from "./TickTime.vue?vue&type=template&id=26e478b0&"
import script from "./TickTime.vue?vue&type=script&lang=js&"
export * from "./TickTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports